import React from 'react';
import Hero from '../../components/Hero/Hero';
import Stats from '../../components/Stats/Stats';
import ServicesGrid from '../../components/ServicesGrid/ServiceGrid'
import WhyChoose from '../../components/WhyChoose/WhyChoose';
import CTA from '../../components/CTA/CTA';
import './Home.scss';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <Stats />
      <ServicesGrid />
      <WhyChoose />
      <CTA />
    </div>
  );
};

export default Home;